import React from 'react'
import DesktopProject from '../Components/Project/DesktopProject'
// import ProjectCard from '../Components/Project/ProjectCard'

export const Projects = () => {
  return (
    <div id="projects">
      <h1 style={{textAlign:"center", fontSize:"30px" ,color:"lightblue", marginBottom:"30px"}}>Projects</h1>
    <DesktopProject/>
    {/* <ProjectCard/> */}
    </div>
  )
}
